// Shared by the two v2 create-wizard slices (createSdCampaignReducer /
// createSbCampaignReducer). Both expose exactly one generic writer —
// `setField({ path, value })` — so a step component never needs its own action
// per input, and the slice shape stays the single source of truth for §5's
// payload contract.
//
// Runs inside immer (RTK's createSlice), so mutating the draft is correct here.
// Missing intermediate objects are created rather than thrown on, which keeps a
// step that writes `campaign.costControl.value` working even if a later shape
// change drops the parent default.
export const setFieldPath = (target: any, path: string, value: unknown) => {
  const parts = path.split(".");
  let node = target;
  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i];
    if (node[key] === undefined || node[key] === null) node[key] = {};
    node = node[key];
  }
  node[parts[parts.length - 1]] = value;
};

// UI-only row ids. The launch adapters (B7 / C9) strip `id` and `label` before
// posting — they exist for React keys and for the "remove this row" affordance,
// and Amazon knows nothing about them.
let rowSeq = 0;
export const nextRowId = (prefix: string) => `${prefix}-${++rowSeq}`;
